import { apis, RequestOptions } from "../../backend";
import { Project } from "../../models/Project";

export async function listProjects(): Promise<Project[]> {
  const projects = await apis.users.get<Project[]>('/projects-v1');

  return projects.map(project => new Project(project));
}

export type SimpleProject = Pick<Project, 'id' | 'name'>;

export async function listSimpleProjects(options?: RequestOptions): Promise<SimpleProject[]> {
  const projects = await apis.users.get<SimpleProject[]>('/project-information-v1/simple', null, options);
  return projects;
}